/**
 * Manual cancellation stored with "Prüfen vor dem Senden" (cancellationConfig.sendAfterReview) whose messages were not
 * sent yet: the office still has to review and send them from the inquiry. Pure (timetable helpers, cards).
 */
export function cancellationPending(config: { sendAfterReview?: boolean; startedCancellationAt?: Date | string } | undefined | null): boolean {
  return !!config?.sendAfterReview && !config.startedCancellationAt;
}
